import request from "@/utils/request/request";

export default {
  //上传文件
  postUpload(data) {
    return request({ url: "common/upload", method: "post", data });
  },
  postUpload2(data) {
    return request({ url: "common/upload2", method: "post", data });
  },

  //获取首页轮播图
  getImgList(params) {
    return request({ url: "index/banner", method: "get", params });
  },

  //个人信息
  getUser(params) {
    return request({ url: "user/info", method: "get", params });
  },

  //获取用户协议
  getyhxy(params) {
    return request({ url: "index/yhxy", method: "get", params });
  },

  //获取隐私政策
  getyszc(params) {
    return request({ url: "index/yszc", method: "get", params });
  },

  getFooter(params) {
    return request({ url: "index/siteinfo", method: "get", params });
  },

  //注册教师
  postRegister(data) {
    return request({ url: "user/register", method: "post", data });
  },

  //发送验证码
  postCode(data) {
    return request({ url: "sms/send", method: "post", data });
  },

  //教师登录
  postLogin1(data) {
    return request({ url: "user/login", method: "post", data });
  },

  //修改个人信息
  editUserInfo(data) {
    return request({ url: "user/profile", method: "post", data });
  },

  //修改密码
  editPassWord(data) {
    return request({ url: "user/changepwd", method: "post", data });
  },

  //评审专家登录
  postLogin2(data) {
    return request({ url: "user/login2", method: "post", data });
  },

  //退出登录
  postLoginOut1(data) {
    return request({ url: "user/logout", method: "post", data });
  },

  //忘记密码
  postForget(data) {
    return request({ url: "user/resetpwd", method: "post", data });
  },


  //赛事通知
  getNotificationList(params) {
    return request({ url: "notice/lists", method: "get", params });
  },

  //赛事通知详情
  getNotificationDetail(params) {
    return request({ url: "notice/noticeDetail", method: "get", params });
  },

  //赛事新闻
  getNewsList(params) {
    return request({ url: "news/lists", method: "get", params });
  },

  //赛事新闻详情
  getNewsDetail(params) {
    return request({ url: "news/newsDetail", method: "get", params });
  },

  //赛事指南  报名流程
  getGuide(params) {
    return request({ url: "guide/index", method: "get", params });
  },

  //下载中心
  getDownloadList(params) {
    return request({ url: "files/lists", method: "get", params });
  },

  //活动赛事
  getMatch(params) {
    return request({ url: "match/index", method: "get", params });
  },

  //提交报名
  postAdd(data) {
    return request({ url: "report/do", method: "post", data });
  },

  //修改报名
  postEdit1(data) {
    return request({ url: "report/edit", method: "post", data });
  },

  //设置复赛作品
  postEdit2(data) {
    return request({ url: "report/file1", method: "post", data });
  },

  //设置决赛作品
  postEdit3(data) {
    return request({ url: "report/file2", method: "post", data });
  },

  //教师 我的比赛
  getMybsList(params) {
    return request({ url: "report/teacherList", method: "get", params });
  },

  //活动赛事列表
  getmatchtList(params) {
    return request({ url: "expert/match", method: "get", params });
  },

  //评审作品列表
  getreportList(params) {
    return request({ url: "expert/reportList", method: "get", params });
  },

  //教师 报名信息详情
  getMyInfoList(params) {
    return request({ url: "report/info", method: "get", params });
  },

  //打分
  getScore(params) {
    return request({ url: "expert/score", method: "get", params });
  },

  //查看是否已经提交过报名信息
  postCheck(data) {
    return request({ url: "report/isDo", method: "post", data });
  },

  //获取qrcode
  getQrcode(params) {
    return request({ url: "user/getCode", method: "get", params });
  },


  getIss(params) {
    return request({ url: "user/wxlogin", method: "get", params });
  },

  getcode1(params) {
    return request({ url: "user/openid", method: "get", params });
  },

  postzc(data) {
    return request({ url: "user/firstDeal", method: "post", data });
  },

  //预览文件
  getImm(params) {
    return request({ url: "imm/index", method: "get", params });
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js